import React from "react";
import "components/fragments/custom-checkbox/CustomCheckbox.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";

export default class CustomCheckbox extends React.Component {
  handleClickCheckbox = (id) => {
    const { onClickCheckbox, disabled, selected } = this.props;
    if (!disabled && onClickCheckbox) {
      onClickCheckbox(id);
    }
    if (selected) {
      // to deselect
      onClickCheckbox(id);
    }
  };

  render() {
    const { label, selected, id, disabled } = this.props;
    return (
      <div
        className={
          "custom-checkbox  " + (selected ? "custom-checkbox--selected" : "")
        }
      >
        <FontAwesomeIcon
          icon={faCheckSquare}
          aria-hidden={true}
          className={"custom-checkbox__checked"}
        />
        <input
          type="checkbox"
          name="course"
          id={id}
          checked={selected}
          onChange={() => this.handleClickCheckbox(id)}
        />
        <label
          htmlFor={id}
          className={
            "custom-checkbox__label" +
            (disabled ? "--disabled" : "") +
            (selected ? "--selected" : "")
          }
        >
          <span>{label}</span>
        </label>
      </div>
    );
  }
}
